'use client';

import { JSX, useEffect, useState } from 'react';

const LOADING_INDICATOR_ID = 'q-intermediate-loading-template';

/**
 * Announces the Qualified widget's loading indicator to screen readers.
 * Qualified injects that indicator without a live region, so we watch for it and mirror its presence in our own.
 */
export const QualifiedLoadingAnnouncer = (): JSX.Element => {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const syncIsLoading = () => setIsLoading(document.getElementById(LOADING_INDICATOR_ID) !== null);
        const observer = new MutationObserver(syncIsLoading);
        observer.observe(document.body, { childList: true, subtree: true });
        syncIsLoading();

        return () => observer.disconnect();
    }, []);

    return (
        <div role="status" className="sr-only">
            {isLoading ? 'Loading' : ''}
        </div>
    );
};
